import multiguard from 'vue-router-multiguard';
import FobPointsList from './Suppliers/FobPoints/FobPointsList';
import FobPointForm from './Suppliers/FobPoints/FobPointForm';
import AdminAsiSuppliers from '../admin/asi/suppliers';
import { hasAccess, hasDistributorAccess, ifAuthenticated, isActive, ROLES_ACCESS } from '../utils';
import { account } from '../../routes.account';
import { reportsRoutes } from '../Application/Reports/routes';

const adminRoutes = [
  {
    path: '/admin',
    name: 'admin/index',
    meta: {
      id: [
        ...ROLES_ACCESS.ADMIN,
        ...ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING,
        ...ROLES_ACCESS.ADMIN_MPOWER_ADMIN,
        ...ROLES_ACCESS.ADMIN_MPOWER_PRODUCT_MANAGER,
        ...ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER
      ]
    },
    component: () => import('@/portals/Administration/Index'),
    beforeEnter: multiguard([ifAuthenticated, isActive, hasDistributorAccess, hasAccess]),
    children: [
      ...account('admin'),
      ...reportsRoutes('/admin').map((e) => ({ ...e, meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] } })),
      ...[
        {
          path: 'all-logs',
          name: 'Log',
          component: () => import('@/portals/Administration/Logs/main.page')
        },
        {
          path: 'services',
          name: 'Services',
          component: () => import('@/portals/Administration/Services')
        },
        {
          path: 'dashboard',
          name: 'admin/dashboard',
          component: () => import('@/portals/Administration/Dashboard'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[0]] }
        },
        {
          path: 'forum',
          name: 'admin/forum',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/ForumHome')
        },
        {
          path: 'forum/new',
          name: 'admin/forum-new',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/PostComposer')
        },
        {
          path: 'forum/messages',
          name: 'admin/forum-messages',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/ForumInbox')
        },
        {
          path: 'forum/messages/:id',
          name: 'admin/forum-conversation',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/ForumConversation')
        },
        {
          path: 'forum/review',
          name: 'admin/forum-review',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/ForumReview')
        },
        {
          path: 'forum/:id',
          name: 'admin/forum-post',
          meta: { available: true },
          component: () => import('@/portals/Application/Forum/PostDetail')
        },
        {
          path: 'reporting',
          name: 'admin/reporting',
          component: () => import('@/portals/Administration/Reporting'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] }
        },
        {
          path: 'orders',
          name: 'admin/orders',
          component: () => import('@/portals/Administration/Orders'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId',
          component: () => import('@/portals/Application/Orders/OrderView'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/purchase-orders/create',
          component: () => import('@/portals/Application/Orders/PurchaseOrderFormTemplate'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/purchase-orders/create',
          component: () => import('@/portals/Application/Orders/PurchaseOrderFormTemplate'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/duplicate',
          component: () => import('@/portals/Application/Orders/OrderDuplicateForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/purchase-orders/:friendlyPurchaseOrderDetailId',
          component: () => import('@/portals/Application/Orders/PurchaseOrderFormTemplate'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/purchase-orders/:friendlyPurchaseOrderDetailId/duplicate',
          component: () => import('@/portals/Application/Orders/PurchaseOrderFormTemplate'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/sendpurchase/:purchaseOrderId',
          name: 'admin/orders/sendpurchase/:orderId/:purchaseOrderId',
          component: () => import('@/portals/Application/Orders/SendPurchaseOrder'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/sendinvoice',
          name: 'admin/orders/:orderId/sendinvoice',
          component: () => import(/* webpackChunkName: "orders" */ '@/portals/Application/Orders/SendCustomerInvoice'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/sendquote',
          name: 'admin/orders/:orderId/sendquote',
          component: () => import(/* webpackChunkName: "orders" */ '@/portals/Application/Orders/SendCustomerQuote'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/sendreceipt',
          name: 'admin/orders/:orderId/sendreceipt',
          component: () => import(/* webpackChunkName: "orders" */ '@/portals/Application/Orders/SendOrderReceipt'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: '/admin/orders/:orderId/send-presentation',
          name: 'admin/orders/:orderId/send-presentation',
          component: () => import('@/portals/Application/Orders/SendPresentation'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[1]] }
        },
        {
          path: 'products',
          name: 'admin/products',
          component: () => import('@/portals/Administration/Products'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_PRODUCT_MANAGER[0]] }
        },
        {
          path: 'products/create',
          component: () => import('@/portals/Administration/Products/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_PRODUCT_MANAGER[0]] }
        },
        {
          path: 'products/:slug/edit',
          component: () => import('@/portals/Administration/Products/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_PRODUCT_MANAGER[0]] }
        },
        {
          path: 'categories',
          name: 'admin/categories',
          component: () => import('@/portals/Administration/Categories/List'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ADMIN[0]] }
        },
        {
          path: 'categories/create',
          name: 'admin/categories/create',
          component: () => import('@/portals/Administration/Categories/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ADMIN[0]] }
        },

        {
          path: 'categories/:categoryId',
          name: 'admin/categories/:id',
          component: () => import('@/portals/Administration/Categories/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ADMIN[0]] }
        },
        {
          path: 'ps-categories-mapping',
          component: () => import('@/portals/Administration/PsCategoriesMapping'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ADMIN[0]] }
        },
        {
          path: 'automations',
          component: () => import('@/portals/Administration/Automations'),
          children: [
            {
              path: '',
              redirect: 'rules'
            },
            {
              path: 'rules',
              children: [
                {
                  path: '',
                  redirect: 'all'
                },
                {
                  path: 'all',
                  name: 'admin/automations/rules/all',
                  component: () => import('@/portals/Administration/Automations/Rules/List')
                },
                {
                  path: 'create',
                  name: 'admin/automations/rules/create',
                  component: () => import('@/portals/Administration/Automations/Rules/Form')
                },
                {
                  path: ':rule_id',
                  name: 'admin/automations/rules/edit',
                  component: () => import('@/portals/Administration/Automations/Rules/Form')
                }
              ],
              component: () => import('@/portals/Administration/Automations/Rules')
            },

            {
              path: 'logs',
              name: 'admin/automations/logs',
              component: () => import('@/portals/Administration/Automations/Logs')
            },
            {
              path: 'templates',
              name: 'admin/automations/templates',
              component: () => import('@/portals/Administration/Automations/Templates')
            }
          ]
        },
        {
          path: 'billing',
          component: () => import('@/portals/Administration/Billing'),
          children: [
            {
              path: '',
              redirect: 'distributors'
            },
            {
              path: 'ai-usage',
              name: 'admin/billing/ai-usage',
              component: () => import('@/portals/Administration/Billing/AiUsage')
            },
            {
              path: 'distributors',
              name: 'admin/billing/distributors',
              component: () => import('@/portals/Administration/Billing/Distributors'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] }
            },
            {
              path: 'suppliers',
              name: 'admin/billing/suppliers',
              component: () => import('@/portals/Administration/Billing/Suppliers'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] }
            },
            {
              path: 'invoices',
              name: 'admin/billing/invoices',
              component: () => import('@/portals/Administration/Billing/Invoices'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] }
            },
            {
              path: 'distributors/:distributorId',
              component: () => import('@/portals/Administration/Billing/Distributors/Detail'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] },
              children: [
                {
                  path: '',
                  redirect: 'billing-details'
                },
                {
                  path: 'billing-details',
                  name: 'admin/billing/distributors/:distributorId/billing-details',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/BillingDetails')
                },
                {
                  path: 'subscription',
                  redirect: 'billing-details'
                },
                {
                  path: 'ai-usage',
                  name: 'admin/billing/distributors/:distributorId/ai-usage',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/AiUsage')
                },
                {
                  path: 'support-tickets',
                  name: 'admin/billing/distributors/:distributorId/support-tickets',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/SupportTickets')
                },
                {
                  path: 'order-fees',
                  name: 'admin/billing/distributors/:distributorId/order-fees',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/OrderFees')
                },
                {
                  path: 'invoices',
                  name: 'admin/billing/distributors/:distributorId/invoices',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/Invoices')
                },
                {
                  path: 'activity',
                  name: 'admin/billing/distributors/:distributorId/activity',
                  component: () => import('@/portals/Administration/Billing/Distributors/tabs/Activity')
                }
              ]
            },
            {
              path: 'suppliers/:supplierId',
              component: () => import('@/portals/Administration/Billing/Suppliers/Detail'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] },
              children: [
                {
                  path: '',
                  redirect: 'advertising-billing'
                },
                {
                  path: 'advertising-billing',
                  name: 'admin/billing/suppliers/:supplierId/advertising-billing',
                  component: () => import('@/portals/Administration/Billing/Suppliers/tabs/AdvertisingBillingDetails')
                },
                {
                  path: 'invoices',
                  name: 'admin/billing/suppliers/:supplierId/invoices',
                  component: () => import('@/portals/Administration/Billing/Suppliers/tabs/Invoices')
                }
              ]
            },
            {
              path: 'support',
              name: 'admin/billing/support',
              component: () => import('@/portals/Administration/Billing/Support'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_ACCOUNTING[0]] }
            }
          ]
        },
        {
          path: 'distributors',
          component: () => import('@/portals/Administration/Distributors/pages/Index'),
          children: [
            {
              path: '',
              name: 'admin/distributors',
              component: () => import('@/portals/Administration/Distributors/pages/List'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[5]] }
            },
            {
              path: 'domains',
              name: 'admin/distributors/domains',
              component: () => import('@/portals/Administration/Domains'),
              meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[5]] }
            },
            {
              path: 'followups',
              name: 'admin/distributors/followups',
              component: () => import('@/portals/Administration/Distributors/pages/FollowUps'),
              meta: { id: [ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN] }
            },
            {
              path: 'aiusage',
              name: 'admin/distributors/aiusage',
              component: () => import('@/portals/Administration/Distributors/pages/AIUsage'),
              meta: { id: [ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN] }
            }
          ]
        },
        {
          path: '/admin/settings/walkthroughs',
          name: 'admin/settings/walkthroughs',
          component: () => import('@/portals/Administration/Walkthroughs')
        },
        {
          path: '/admin/settings/walkthroughs/checklist',
          name: 'admin/settings/walkthroughs/checklist',
          component: () => import('@/portals/Administration/Checklist')
        },
        {
          path: '/admin/walkthroughs/elastic',
          name: 'admin/elastic',
          component: () => import('@/portals/Administration/Elastic')
        },
        {
          path: '/admin/walkthroughs/cache',
          name: 'admin/cache',
          component: () => import('@/portals/Administration/CacheManagement')
        },
        {
          path: '/admin/settings/walkthroughs/integration',
          name: 'admin/settings/walkthroughs/integration',
          component: () => import('@/portals/Administration/Integration')
        },
        {
          path: '/admin/settings/walkthroughs/global-integration',
          name: 'admin/settings/walkthroughs/global-integration',
          component: () => import('@/portals/Administration/GlobalIntegration')
        },
        {
          path: '/admin/settings/walkthroughs/api-tokens',
          name: 'admin/settings/walkthroughs/api-tokens',
          component: () => import('@/portals/Administration/ApiTokens')
        },
        {
          path: '/admin/settings/walkthroughs/reference-fields',
          name: 'admin/settings/walkthroughs/reference-fields',
          component: () => import('@/portals/Administration/ReferenceFields')
        },
        {
          path: '/admin/settings/plans',
          name: 'admin/settings/plans',
          component: () => import('@/portals/Administration/Settings/Plans'),
          meta: { id: [ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN] }
        },
        {
          path: '/admin/notifications',
          name: 'admin/notifications',
          component: () => import('@/portals/Administration/Notifications')
        },
        {
          path: '/admin/tracking-links',
          name: 'admin/tracking-links',
          component: () => import('@/portals/Administration/TrackingLink')
        },
        {
          path: '/admin/opportunities',
          name: 'admin/opportunities',
          component: () => import('@/portals/Administration/Opportunities')
        },
        {
          path: '/admin/theme-media',
          name: 'admin/theme-media',
          component: () => import('@/portals/Administration/ThemeMedia/index.vue')
        },
        {
          path: '/admin/domains',
          name: 'admin/domains',
          component: () => import('@/portals/Administration/Domains')
        },
        {
          path: 'distributors/create',
          name: 'admin/distributors/create',
          component: () => import('@/portals/Administration/Distributors/pages/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[5]] }
        },
        {
          path: 'distributors/:distributorId',
          name: 'admin/distributors/:distributorId',
          component: () => import('@/portals/Administration/Distributors/pages/View'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[5]] }
        },
        {
          path: 'users',
          name: 'admin/users',
          component: () => import('@/portals/Administration/Users'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[4]] }
        },
        {
          path: 'users/create',
          name: 'admin/users/create',
          component: () => import('@/components/UserForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[4]] }
        },
        {
          path: 'users/:userId/edit',
          name: 'admin/users/:userId/edit',
          component: () => import('@/components/UserForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[4]] }
        },
        {
          path: 'users/:userId/changepassword',
          name: 'admin/users/:userId/changepassword',
          component: () => import('@/components/ChangePassword'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[4]] }
        },
        {
          path: 'suppliers',
          component: () => import('@/portals/Administration/Suppliers'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'asi/suppliers',
          component: AdminAsiSuppliers,
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'suppliers/create',
          name: 'admin/suppliers/create',
          component: () => import('@/portals/Administration/Suppliers/SupplierForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'suppliers/:supplierId/edit',
          name: 'admin/suppliers/:supplierId/edit',
          component: () => import('@/portals/Administration/Suppliers/SupplierForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'suppliers/email',
          component: () => import('@/portals/Administration/Suppliers/Email/SupplierBatchEmail'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] },
          children: [
            { path: '', redirect: 'lists' },
            {
              path: 'lists',
              name: 'admin/suppliers/email/lists',
              component: () => import('@/portals/Application/Customers/components/EmailsLists'),
              props: { scope: 'supplier' }
            },
            {
              path: 'lists/create',
              name: 'admin/suppliers/email/lists/create',
              component: () => import('@/portals/Application/Customers/components/EmailsLists/Form'),
              props: { scope: 'supplier' }
            },
            {
              path: 'lists/:emailsList',
              name: 'admin/suppliers/email/lists/view',
              component: () => import('@/portals/Application/Customers/components/EmailsLists/View'),
              props: { scope: 'supplier' }
            },
            {
              path: 'lists/:emailsList/edit',
              name: 'admin/suppliers/email/lists/edit',
              component: () => import('@/portals/Application/Customers/components/EmailsLists/Form'),
              props: { scope: 'supplier' }
            },
            {
              path: 'send',
              name: 'admin/suppliers/email/send',
              component: () => import('@/portals/Application/Customers/components/EmailsLists/Send'),
              props: { scope: 'supplier' }
            },
            {
              path: 'activity',
              name: 'admin/suppliers/email/activity',
              component: () => import('@/portals/Application/Customers/components/EmailsActivities'),
              props: { scope: 'supplier' }
            },
            {
              path: 'activity/:emailsActivity',
              name: 'admin/suppliers/email/activity/view',
              component: () => import('@/portals/Application/Customers/components/EmailsActivities/View'),
              props: { scope: 'supplier' }
            },
            {
              path: 'templates',
              name: 'admin/suppliers/email/templates',
              component: () => import('@/portals/Application/Customers/components/EmailTemplates'),
              props: { scope: 'supplier' }
            },
            {
              path: 'templates/create',
              name: 'admin/suppliers/email/templates/create',
              component: () => import('@/portals/Application/Customers/components/EmailTemplates/Form'),
              props: { scope: 'supplier' }
            },
            {
              path: 'templates/:emailTemplate/edit',
              name: 'admin/suppliers/email/templates/edit',
              component: () => import('@/portals/Application/Customers/components/EmailTemplates/Form'),
              props: { scope: 'supplier' }
            }
          ]
        },
        {
          path: 'suppliers/:supplierId',
          component: () => import('@/portals/Administration/Suppliers/View')
        },
        {
          path: 'leads',
          name: 'admin/leads',
          component: () => import('@/portals/Administration/Leads/List'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'leads/campaigns',
          name: 'admin/leads/campaigns',
          component: () => import('@/portals/Administration/Leads/Campaigns'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'leads/campaigns/:campaignId',
          name: 'admin/leads/campaigns/:campaignId',
          component: () => import('@/portals/Administration/Leads/CampaignView'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'leads/templates',
          name: 'admin/leads/templates',
          component: () => import('@/portals/Administration/Leads/LeadTemplates'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'leads/discover',
          name: 'admin/leads/discover',
          component: () => import('@/portals/Administration/Leads/Discover'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'leads/:leadId',
          name: 'admin/leads/:leadId',
          component: () => import('@/portals/Administration/Leads/View'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[2]] }
        },
        {
          path: 'components/create',
          name: 'admin/components/create',
          component: () => import('@/portals/Administration/Stores/Components/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        {
          path: 'components/edit/:componentId',
          name: 'admin/components/edit/:componentId',
          component: () => import('@/portals/Administration/Stores/Components/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },

        {
          path: 'fob-points',
          component: FobPointsList
        },
        {
          path: 'fob-points/create',
          component: FobPointForm
        },
        {
          path: 'fob-points/:fobPointId/edit',
          component: FobPointForm
        },
        {
          path: 'stores',
          name: 'admin/stores',
          component: () => import('@/portals/Administration/Stores'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        {
          path: 'stores/create',
          name: 'admin/stores/create',
          component: () => import('@/components/Stores/Form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        {
          path: 'stores/:storeId/products/create',
          name: 'admin/stores/:storeId/products/create',
          component: () => import('@/components/Stores/Editor/Products/form'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        // {
        //   path: 'stores/:storeId/products/:slug/edit',
        //   name: 'admin/stores/:storeId/products/:slug/edit',
        //   component: () => import('@/components/Stores/Editor/Products/form')
        // },
        {
          path: 'stores/:storeId',
          name: 'admin/stores/:storeId',
          component: () => import('@/components/Stores/Editor/Index'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        {
          path: 'design-blocks/create',
          name: 'admin/design-blocks/create',
          component: () => import('@/portals/Administration/Stores/DesignBlocks/DesignBlockForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        },
        {
          path: 'design-blocks/:designBlockId',
          name: 'admin/design-blocks/:designBlockId',
          component: () => import('@/portals/Administration/Stores/DesignBlocks/DesignBlockForm'),
          meta: { id: [ROLES_ACCESS.ADMIN_MPOWER_SUPPLIER[3]] }
        }
      ].map((e) => {
        e.beforeEnter = multiguard([ifAuthenticated, isActive, hasDistributorAccess, hasAccess]);
        return e;
      })
    ]
  }
];
export { adminRoutes as default };
